import React, { createContext, useCallback, useState } from 'react';
import BillFormatService from 'services/BillFormatService';

export const BillFormatContext = createContext();

function BillFormatProvider({ children }) {
  const [billFormats, setBillFormats] = useState({});

  const getBillFormat = useCallback(
    async (terminalId) => {
      if (billFormats[terminalId]) {
        return billFormats[terminalId];
      }

      const data = await BillFormatService.getBillFormat(terminalId);
      setBillFormats((prev) => ({ ...prev, [terminalId]: data }));
      return data;
    },
    [billFormats]
  );

  const updateBillFormat = useCallback(async (data, terminalId) => {
    const updatedData = await BillFormatService.updateBillFormat(data, terminalId);
    setBillFormats((prev) => ({ ...prev, [terminalId]: updatedData }));
    return updatedData;
  }, []);

  const clearCache = useCallback(() => {
    setBillFormats({});
  }, []);

  return (
    <BillFormatContext.Provider value={{ getBillFormat, updateBillFormat, clearCache }}>
      {children}
    </BillFormatContext.Provider>
  );
}

export default BillFormatProvider;
